module.exports = __webpack_public_path__ + "static/media/iconeRemetente.f2448fbc.svg";